module.exports = __webpack_public_path__ + "static/media/Dell UltraSharp 5K Monitor 27\" 90deg.d7a26172.png";